import { isArray } from 'lodash';

const { blank } = require("./rubyRailsMethodsToJs");

function selectDistinct(payload) {
    if (!blank(payload.asset_page) || !blank(payload.region) || !blank(payload.projects) || !blank(payload.codings) || !blank(payload.sort)) {
        return { distinct: 'id' };
    }
    return {};
}

function page_entries_info(collection, options = {}) {
    if (("distinct" in options)) {
        console.log("distinct present");
    } else {
        console.log("distinct not present");
    }
}

function pagination(collection, options = {}) {
    page_entries_info(collection, options);
}

function concatUrl(query, newParams) {
	if (query && newParams) return `${query}&${newParams}`;
	if (query && !newParams) return query;

	return newParams;
}

export const normalize = (pagination) => {
    let obj = {};

    Object.keys(pagination).forEach(k => {
        const newKey = k.replace(/\.?([A-Z]+)/g, function (x, y) { return "_" + y.toLowerCase() }).replace(/^_/, "");
        obj[newKey] = pagination[k];
    })

    return obj;
}

export const getUrlParams = (data, key = '', isNormalize = true) => {
    if (!data) return '';

    let query = '';
    const normalized = isNormalize ? normalize(data) : data;

    Object.keys(normalized).forEach((param, i) => {
			if (!normalized[param]) return;

			if (
                typeof normalized[param] === 'object' &&
                Object.keys(normalized[param]).length && 
                !isArray(normalized[param])
            ) {
				query = concatUrl(query, getUrlParams(normalized[param], param));
            } else if (isArray(normalized[param])) {
                normalized[param].forEach((item, i) => {
                    if (typeof item === 'object') {
                        query = concatUrl(query, getUrlParams(item, `${param}[${i}]`));
                    } else {
                        query = concatUrl(query, `${param}[]=${item}`);
                    }
                })
            } else {
                if (normalized[param] === '') return;
                let paramKey = param;
				if (key) paramKey = `[${param}]`
                query = concatUrl(query, `${key}${paramKey}=${normalized[param]}`);
			}
    });

    return query;
}

export default {
    selectDistinct,
    pagination
}
// module.exports.selectDistinct = selectDistinct;
// module.exports.pagination = pagination;
